module.exports = __webpack_public_path__ + "img/one.384ba237.png";